/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Pricing_TitleInputs */

const en_seo_pricing_title = /** @type {(inputs: Seo_Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing for trainers and clubs`)
};

const pl_seo_pricing_title = /** @type {(inputs: Seo_Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cennik dla trenerów i klubów`)
};

/**
* | output |
* | --- |
* | "Pricing for trainers and clubs" |
*
* @param {Seo_Pricing_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seo_pricing_title = /** @type {((inputs?: Seo_Pricing_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Pricing_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seo_pricing_title(inputs)
	return en_seo_pricing_title(inputs)
});